var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptystate2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 281,
    viewBox: "0 0 278 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139 278C215.768 278 278 215.768 278 139C278 62.2324 215.768 0 139 0C62.2324 0 0 62.2324 0 139C0 215.768 62.2324 278 139 278Z",
    fill: "#FFECEC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1133_1538)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1133_1538",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 278,
    height: 278
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139 278C215.768 278 278 215.768 278 139C278 62.2324 215.768 0 139 0C62.2324 0 0 62.2324 0 139C0 215.768 62.2324 278 139 278Z",
    fill: "#FFECEC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1133_1538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.692 79.6934H59.3057C54.1879 79.6934 50.0391 83.8422 50.0391 88.96V283.56C50.0391 288.678 54.1879 292.827 59.3057 292.827H218.692C223.81 292.827 227.959 288.678 227.959 283.56V88.96C227.959 83.8422 223.81 79.6934 218.692 79.6934Z",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.321 98.2266H74.1342C71.0635 98.2266 68.5742 100.716 68.5742 103.787C68.5742 106.857 71.0635 109.347 74.1342 109.347H122.321C125.392 109.347 127.881 106.857 127.881 103.787C127.881 100.716 125.392 98.2266 122.321 98.2266Z",
    fill: "#FFECEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.321 176.066H74.1342C71.0635 176.066 68.5742 178.556 68.5742 181.626C68.5742 184.697 71.0635 187.186 74.1342 187.186H122.321C125.392 187.186 127.881 184.697 127.881 181.626C127.881 178.556 125.392 176.066 122.321 176.066Z",
    fill: "#FFECEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200.159 126.026H77.8391C73.7448 126.026 70.4258 129.345 70.4258 133.44V151.973C70.4258 156.067 73.7448 159.386 77.8391 159.386H200.159C204.253 159.386 207.572 156.067 207.572 151.973V133.44C207.572 129.345 204.253 126.026 200.159 126.026Z",
    stroke: "#FE5558",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M200.161 202.014H77.8409C72.723 202.014 68.5742 206.162 68.5742 211.28V226.107C68.5742 231.225 72.723 235.374 77.8409 235.374H200.161C205.279 235.374 209.428 231.225 209.428 226.107V211.28C209.428 206.162 205.279 202.014 200.161 202.014Z",
    fill: "#FFECEC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.384 163.093C164.502 163.093 168.651 158.945 168.651 153.827C168.651 148.709 164.502 144.56 159.384 144.56C154.266 144.56 150.117 148.709 150.117 153.827C150.117 158.945 154.266 163.093 159.384 163.093Z",
    fill: "#FFECEC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M166.626 193.432C165.143 193.432 163.759 193.432 162.499 193.352C160.946 193.247 159.453 192.716 158.183 191.817C156.913 190.918 155.915 189.686 155.3 188.257L147.481 172.804C146.908 172.136 146.621 171.269 146.684 170.391C146.748 169.513 147.155 168.696 147.818 168.117C148.362 167.68 149.04 167.445 149.737 167.452C150.25 167.467 150.754 167.593 151.213 167.821C151.673 168.05 152.078 168.375 152.4 168.775L155.951 173.621L156.005 173.684V155.272C156.005 154.358 156.367 153.482 157.013 152.836C157.659 152.19 158.535 151.827 159.449 151.827C160.362 151.827 161.239 152.19 161.885 152.836C162.53 153.482 162.893 154.358 162.893 155.272V167.318C162.853 166.875 162.906 166.428 163.048 166.006C163.191 165.585 163.419 165.197 163.719 164.869C164.02 164.54 164.385 164.278 164.792 164.098C165.2 163.919 165.64 163.826 166.085 163.826C166.53 163.826 166.97 163.919 167.377 164.098C167.785 164.278 168.15 164.54 168.45 164.869C168.751 165.197 168.979 165.585 169.121 166.006C169.263 166.428 169.316 166.875 169.276 167.318V169.83C169.236 169.386 169.289 168.939 169.431 168.518C169.573 168.096 169.802 167.708 170.102 167.38C170.402 167.051 170.768 166.789 171.175 166.609C171.582 166.43 172.023 166.337 172.468 166.337C172.913 166.337 173.353 166.43 173.76 166.609C174.168 166.789 174.533 167.051 174.833 167.38C175.133 167.708 175.362 168.096 175.504 168.518C175.646 168.939 175.699 169.386 175.659 169.83V171.764C175.619 171.321 175.672 170.874 175.814 170.453C175.956 170.031 176.185 169.643 176.485 169.315C176.785 168.986 177.151 168.724 177.558 168.544C177.965 168.365 178.405 168.272 178.851 168.272C179.296 168.272 179.736 168.365 180.143 168.544C180.55 168.724 180.916 168.986 181.216 169.315C181.516 169.643 181.745 170.031 181.887 170.453C182.029 170.874 182.082 171.321 182.042 171.764V183.509C181.979 187.121 180.346 193.211 174.603 193.211C174.186 193.23 170.653 193.434 166.633 193.434L166.626 193.432Z",
    fill: "#FE5558",
    stroke: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.027 44.0615L143.659 49.3246L148.922 49.9825L145.308 54.0351L146.291 59.8508L141.027 57.2193L135.764 59.8508L136.756 54.0351L133.133 49.9825L138.396 49.3246L141.027 44.0615Z",
    fill: "#EC3337"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M177.465 44.0615L180.097 49.3246L185.36 49.9825L181.746 54.0351L182.728 59.8508L177.465 57.2193L172.202 59.8508L173.193 54.0351L169.57 49.9825L174.833 49.3246L177.465 44.0615Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.59 44.0615L107.222 49.3246L112.485 49.9825L108.871 54.0351L109.853 59.8508L104.59 57.2193L99.3269 59.8508L100.318 54.0351L96.6953 49.9825L101.958 49.3246L104.59 44.0615Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1133_1538",
    x: 44.0391,
    y: 70.6934,
    width: 189.922,
    height: 210.307,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1133_1538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1133_1538",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptystate2);
export default __webpack_public_path__ + "static/media/emptystate2.16f5342a87bfd446f56e570894e8681e.svg";
export { ForwardRef as ReactComponent };